import React from "react";
import Shop from "../sections/Shop.jsx";
export default function PageShop() { return <Shop />; }
